"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URLS_ROUTE = exports.SITEMAPS_ROUTE = exports.LANGUAGE_SETTINGS_ROUTE = exports.DOMAINS_ROUTE = exports.BASE_DOMAINS_TAB_ROUTE = void 0;
var BASE_DOMAINS_TAB_ROUTE = 'marketing/domains';
exports.BASE_DOMAINS_TAB_ROUTE = BASE_DOMAINS_TAB_ROUTE;
var DOMAINS_ROUTE = 'domains';
exports.DOMAINS_ROUTE = DOMAINS_ROUTE;
var LANGUAGE_SETTINGS_ROUTE = 'languageSettings';
exports.LANGUAGE_SETTINGS_ROUTE = LANGUAGE_SETTINGS_ROUTE;
var SITEMAPS_ROUTE = 'sitemaps';
exports.SITEMAPS_ROUTE = SITEMAPS_ROUTE;
var URLS_ROUTE = 'urlRedirects';
exports.URLS_ROUTE = URLS_ROUTE;